import React from "react";
import "./CustomToggle.scss";

interface customToggleParams {
  isSelected: boolean;
  type: number;
  confirmToast: (option: any, checked: boolean) => void;
}

const CustomToggle: React.FC<customToggleParams> = (props) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={(e) => {
          props.confirmToast(props.type, e.target.checked);
        }}
      ></input>
      <span className="slider round"></span>
    </label>
  );
};

export default CustomToggle;
